export const SALES_PHONE_E164 = '254726642205';

export function whatsAppHref(prefillText = '') {
  const base = `https://wa.me/${SALES_PHONE_E164}`;
  if (!prefillText) return base;
  return `${base}?text=${encodeURIComponent(prefillText)}`;
}
